import { render, staticRenderFns } from "./form.producto.barcode.vue?vue&type=template&id=0f976f60&scoped=true&"
import script from "./form.producto.barcode.vue?vue&type=script&lang=js&"
export * from "./form.producto.barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f976f60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
